export enum EnumEmailProvider {
  Gmail = 1,
  Yahoo,
  Outlook,
  Aol,
}